/**
 * User preferences stored in session_data.appv5
 */
export interface ICaseViewPreference {
    id: string; // View ID
    visible: boolean;
    order: number;
}

export interface IUserPreferencesAppV5 {
    caseViews: ICaseViewPreference[];
    darkMode: boolean;
}

/**
 * Root session_data structure
 */
export interface ISessionData {
    appv5?: IUserPreferencesAppV5;
    pinnedViews?: string[];
    [key: string]: any;
}

/**
 * Default preferences for new users or users without preferences
 */
export const DEFAULT_USER_PREFERENCES: IUserPreferencesAppV5 = {
    caseViews: [],
    darkMode: false,
};

